/**@internal
 *
 */
export var MessageType;
(function (MessageType) {
    MessageType[MessageType["Response"] = 0] = "Response";
    MessageType[MessageType["Notification"] = 1] = "Notification";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=messages.js.map